import React, { Fragment, useMemo, useState } from "react";
import Seo from "../Slot/seo";
import { Box, Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import useSubTypeListV2 from "../../hook/useSubTypeList_v2";
import MobileSearch from "../Search/MobileSearch";
import TopGameBoard from "../../components/GameComponents/TopGameBoard/TopGameBoard";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import EventCarouselV4 from "./components/event_carousel_v4";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import MarqueeList from "../../components/marquee/MarqueeList";
import { COMMON_WEB_PATH } from "../../constant";
import JackpotWrapper from "../../components/GameComponents/Jackpot/JackpotWrapper";
import GameCatalog from "../../components/GameCatalog/GameCatalog";
import HomeTitle from "../../components/HomeTitle/HomeTitle";
import StartGameButton from "./StartGameButton";
import useCheckLogin from "../../hook/useCheckLogin";
import useDeviceType from "../../hook/useDeviceType";
import LeaderBoardWrapper from "../../components/GameComponents/LeaderBoard/LeaderBoardWrapper";
import LobbyMenu from "../../components/Menu/LobbyMenu";
import GameSelectorPreview from "./GameSelectorPreview";
import TaiwanMenu from "../../components/Menu/TaiwanMenu";
import TaiwanMenuMobile from "../../components/Menu/TaiwanMenu_mobile";
import LineShare from "../../components/Menu/LineShare";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import { languageTransfer } from "../../utils/languageTransfer";
import i18next from "i18next";
import Carousel from "../../components/Carousel/Carousel";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";
import useLongMachineSetting from "../../hook/useLongMachineSetting";

const Home = () => {
  const handleAllGame = useSelector((state) => state.isHandleAllGame);
  const currentCurrency = useSelector((state) => state.isWalletCurrency);
  const { isLogin, isMachineUser, isMachineDomain } = useCheckLogin();
  const boxBg = useColorModeValue("#EBEDFE", "#394367");
  const [activeMenu, setActiveMenu] = useState("hot");
  const [hoveredGame, setHoveredGame] = useState(null);
  const isMobile = useDeviceType() === "Mobile";

  const { images } = useWebsiteInfo();

  const { topGameList, exclusiveBrandGames, gameListByTypeAndSubType } =
    handleAllGame;
  const subList = useSubTypeListV2({
    forceShowAll: true,
    gameMainTypeFromProps: "SLOT",
  });
  const subGames = useMemo(() => {
    const slot_game_list = gameListByTypeAndSubType?.["SLOT"];
    return Object?.keys(slot_game_list || {})?.map((sub_type, index) => {
      const subGamelist = slot_game_list[sub_type];
      return (
        subGamelist?.length > 0 && (
          <Fragment key={sub_type}>
            <GameCatalog
              list={subGamelist}
              //   wrapperClassName={subGamelist?.length === 0 && "hidden"}
              mainTitle={sub_type}
              observeFalse
              swiperProps={{
                customPerView: "v3-normal-layout",
              }}
              fullImageLayout
              itemClass="2xl:h-[225px] xl:h-[265px] h-[180px]"
              hiddenButtonNavigator
            />
          </Fragment>
        )
      );
    });
  }, [gameListByTypeAndSubType, subList, currentCurrency]);

  const gradientStyle = {
    color: "white",
    WebkitTextStroke: "1px #d485d8",
    textStroke: "1px #d485d8",
    textShadow: `
    -1px -1px 0 #d485d8,  
     1px -1px 0 #d485d8,
    -1px 1px 0 #d485d8,
     1px 1px 0 #d485d8
  `,
    display: "inline-block",
    width: "100%",
    textAlign: "center",
  };

  // 根據activeMenu渲染對應的遊戲內容
  const renderGameContent = useMemo(() => {
    switch (activeMenu) {
      case "exclusive":
        return (
          <Flex>
            <Box
              width={{
                base: "50%",
                lg: "50%",
                xl: "50%",
                "2xl": "40%",
              }}
              sx={{
                "@media screen and (min-width: 1800px)": {
                  width: "35%",
                },
                "@media screen and (min-width: 2100px)": {
                  width: "30%",
                },
              }}
              height="100%"
              position="relative"
            >
              <Box position="fixed" top="10%" w="100%" h="100%">
                <Image
                  src={`${COMMON_WEB_PATH}/911TW/exclusive/new/${
                    hoveredGame?.gameCode || exclusiveBrandGames?.[0]?.gameCode
                  }.webp`}
                  maxW={"30%"}
                  left="18%"
                  fallbackSrc={`${COMMON_WEB_PATH}/911TW/exclusive/simbad.webp`}
                />

                <Flex
                  justifyContent={"center"}
                  alignItems={"center"}
                  bgImage={`${COMMON_WEB_PATH}/911TW/exclusive/exclusiveGameTitleBG.webp`}
                  bgPosition="center"
                  bgRepeat="no-repeat"
                  bgSize="100% 100%"
                  w="30%"
                  maxW={{ base: "none", "2xl": "28%" }}
                  position="absolute"
                  bottom="40%"
                  //left="2%"
                  p="10px 20px"
                >
                  <Text
                    color="transparent"
                    sx={gradientStyle}
                    fontSize={{
                      base: "2xl",
                      xl: "4xl",
                    }}
                    fontWeight="900"
                  >
                    {hoveredGame?.[
                      `gameName${languageTransfer({
                        lang: i18next.language,
                      })}`
                    ] ||
                      exclusiveBrandGames?.[0]?.[
                        `gameName${languageTransfer({
                          lang: i18next.language,
                        })}`
                      ]}
                  </Text>
                </Flex>
                <Image
                  position="absolute"
                  maxW={"40%"}
                  bottom="15%"
                  left="-4%"
                  src={images.exclusiveGameLobbyTitle}
                />
              </Box>
            </Box>
            <Box
              display={{ base: "none", md: "block" }}
              width={{
                base: "50%",
                lg: "50%",
                xl: "50%",
                "2xl": "60%",
              }}
              sx={{
                "@media screen and (min-width: 1800px)": {
                  width: "65%",
                },
                "@media screen and (min-width: 2100px)": {
                  width: "70%",
                },
              }}
            >
              <GameSelector
                hiddenTitle
                mb="10px"
                customSubType="exclusiveBrandGames"
                ExclusiveLobbyStyle
                onGameHover={setHoveredGame} // 傳入setHoveredGame
              />
            </Box>
          </Flex>
        );
      case "hot":
        return (
          <GameSelector
            gameMainTypeFromProps={"HOT"}
            customGamePlatform={"BNG"}
            // hiddenTitle
            customSubType="topGameList"
            isHighlight
            isHot
          />
        );
      case "new":
        return (
          <GameSelector
            gameMainTypeFromProps={"NEW"}
            customGamePlatform={"EG"}
            // hiddenTitle
            mb="10px"
            customSubType="New"
          />
        );
      default:
        // 預設顯示獨家遊戲
        return (
          <GameSelector
            gameMainTypeFromProps={"SLOT"}
            customGamePlatform={"EG"}
            hiddenTitle
            mb="10px"
            customSubType="exclusiveBrandGames"
          />
        );
    }
  }, [activeMenu, hoveredGame, exclusiveBrandGames, gradientStyle]);

  const isMachineLandscape = useIsLandScapeMachine();

  const { longMachineVideoHeight, longMachineStickyTopConfig } =
    useLongMachineSetting();

  return (
    <Fragment>
      <Box minH="calc(100vh - 110px)" display="flex" flexDirection="column">
        <Box
          as="section"
          px="common-y"
          display={{ base: "block", xl: "none" }}
          position="sticky"
          top={{
            base: "50px",
            md: isMachineLandscape ? longMachineStickyTopConfig : "0",
          }}
          bgColor="rgba(0,0,0,0.5)"
          zIndex={100}
        >
          <Box
            display={"flex"}
            justifyContent="space-between"
            alignItems="center"
            gap="5px"
            // my="5px"
          >
            <MarqueeList />
            <MobileSearch listHidden />
          </Box>

          <GameTypeSelector />
        </Box>
        <Box
          // flex="1"
          minH="0" // 這很重要，確保內容不會溢出
          display="flex"
          flexDirection="column"
        >
          <Seo />

          {!isMachineDomain && ( //機台域名不顯示
            <Flex
              my={{
                base: "0px",
                md: "10px",
              }}
              flexDirection={{
                base: "column",
                md: "row",
              }}
              gap={{
                base: "10px",
                md: "0px",
              }}
              px={{
                base: "5px",
                md: "0px",
              }}
              display={{
                base: "flex",
                md: isMachineDomain || isMachineUser ? "none" : "flex",
                xl: "none",
              }}
            >
              <Box
                as="section"
                pt={{
                  base: "5px",
                  md: "0px",
                }}
                w="100%"
              >
                <Carousel />
              </Box>

              {!isMobile ? (
                <LeaderBoardWrapper>
                  <Box
                    w={{
                      base: "100%",
                      md: "35%",
                    }}
                    display={{ base: "none", xl: "block" }}
                    bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/TOP_GAMES_BG2x2.webp')`}
                    bgPosition="center"
                    bgRepeat="no-repeat"
                    bgSize="100%100%"
                    borderRadius={{
                      base: "0px",
                      md: "common",
                    }}
                    py={{
                      base: "20px",
                      md: "35px",
                    }}
                    px={{
                      base: "20px",
                      md: "35px",
                    }}
                    mx={{
                      base: "0px",
                      md: "10px",
                    }}
                  >
                    <TopGameBoard />
                  </Box>
                </LeaderBoardWrapper>
              ) : null}
            </Flex>
          )}
        </Box>
        <Flex justifyContent="space-between" gap="10px">
          <Box
            flex="none" // 確保這部分不會被拉伸
            w={{
              base: "100%",
              xl: "calc(100% - 150px)",
            }}
            py="home-space"
            px="common-y"
            mb={{
              base: "60px",
              sm: "0px",
            }}
          >
            {/* 手機板TOP GAME */}
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              px={{
                base: "0px",
                md: "10px",
              }}
              mb="10px"
              display={{ base: "flex", xl: "none" }}
            >
              <Flex
                bgImage={`${COMMON_WEB_PATH}/911TW/TopGameTitleBG2.webp`}
                bgRepeat={`no-repeat`}
                bgSize={`100% 100%`}
                justifyContent="center"
                alignItems="center"
                w="80%"
              >
                <Image
                  src={`${COMMON_WEB_PATH}/FlyDragon/TOPGAME_Title_mobile.svg`}
                  w="150px"
                  h="25px"
                  my="5px"
                />
              </Flex>
              <Box
                bgImage={`${COMMON_WEB_PATH}/FlyDragon/topGameBG_mobile2.webp?11`}
                bgRepeat={`no-repeat`}
                bgSize={`100% 100%`}
                w="100%"
              >
                <GameCatalog
                  wrapperClassName={`!px-[5px]`}
                  list={topGameList}
                  hiddenArrow
                  // mainTitle={`BINGO`}
                  swiperProps={{
                    spaceBetween: 5,
                  }}
                  listType="none"
                  isHot
                  observeFalse
                  //customFixedWidth="155px"
                  hiddenHeader
                  hideGameName
                  fullImageLayout
                />
              </Box>
            </Flex>
            {/* 手機板熱門遊戲 */}
            {isMobile ? (
              <LeaderBoardWrapper>
                <Box
                  w="100%"
                  px={{
                    base: "0px",
                    xl: "20px",
                  }}
                  mb="10px"
                  display={{ base: "block", xl: "none" }}
                >
                  <TopGameBoard />
                </Box>
              </LeaderBoardWrapper>
            ) : null}
            <Box display={{ base: "none", xl: "block" }}>
              {renderGameContent}
            </Box>
            <Box
              px={{
                base: "0px",
                md: "10px",
              }}
              display={{ base: "block", xl: "none" }}
            >
              <HomeTitle gameType="EXCLUSIVE" />
              <GameSelector
                gameMainTypeFromProps={"SLOT"}
                customGamePlatform={"EG"}
                hiddenTitle
                hiddenGameSearch
                mb="10px"
                customSubType="exclusiveBrandGames" // 顯示獨家遊戲
              />
            </Box>
            <Box
              p="10px"
              px={{
                base: "0px",
                md: "10px",
              }}
              display={{ base: "block", xl: "none" }}
              mb={{
                base: "60px",
                sm: "0px",
              }}
            >
              <HomeTitle gameType="POPULAR" />
              <GameSelector
                gameMainTypeFromProps={"SLOT"}
                customGamePlatform={"BNG"}
                hiddenTitle
                hiddenGameSearch
                customSubType="Popular" // 顯示熱門推薦 最多四十個
                //isNew // 顯示最新遊戲標籤
                isHighlight
              />
            </Box>
          </Box>
          <Box
            display={{
              base: "none",
              xl: "block",
            }}
            w={{
              base: "0px",
              xl: "100%",
            }}
            overflowX={`hidden`}
            position="relative"
            zIndex={1000}
          >
            {/* <TaiwanMenu /> */}
            <LobbyMenu activeMenu={activeMenu} onMenuChange={setActiveMenu} />
          </Box>
        </Flex>
        {/* <Box
          display={{ base: "flex", xl: "none" }}
          position="fixed"
          right={"10px"}
          top={"25%"}
          zIndex={10}
        >
          <TaiwanMenuMobile />
        </Box> */}
        {!isMachineDomain && (
          <Box
            display={{ base: "flex", xl: "none" }}
            position="fixed"
            right={"10px"}
            bottom={"20%"}
            zIndex={10}
          >
            <LineShare />
          </Box>
        )}
      </Box>
    </Fragment>
  );
};

export default Home;
